import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const SET_DISPLAY_CONTACT_REP_SCREEN = `SET_DISPLAY_CONTACT_REP_SCREEN`;
export const SET_CONTACT_REP_SNACKBAR = `SET_CONTACT_REP_SNACKBAR`;

interface ContactUsState {
  displayContactRepScreen: boolean;
  contactRepSnackbar?: 'success' | 'error';
}

const initialState: ContactUsState = {
  displayContactRepScreen: false,
  contactRepSnackbar: undefined,
};

export const {
  actions: { setDisplayContactRepScreen, setContactRepSnackbar },
  reducer: contactRepFormReducer,
} = createSlice({
  name: 'contactRep',
  initialState,
  reducers: {
    setDisplayContactRepScreen(state, action: PayloadAction<boolean>) {
      state.displayContactRepScreen = action.payload;
    },
    setContactRepSnackbar(state, action: PayloadAction<ContactUsState['contactRepSnackbar']>) {
      state.contactRepSnackbar = action.payload;
    },
  },
});
